<template>
  <px-custom-dialog v-model="dialog" content-class="rounded-card" width="1280">
    <template v-slot:activator="{ on }">
      <v-btn icon
             v-on="on">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
    <template v-slot:title>
      Compra
      <v-btn class="ml-3" icon link target="_blank" :to="linkCompra">
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </template>
    <template>
      <px-compra-detalhes is-modal-view
                          :compra-id-prop="compraId"/>
    </template>
  </px-custom-dialog>
</template>

<script>
import CompraDetalhes from '@/modules/compra/detalhes/CompraDetalhes.vue';

export default {
  props: {
    compraId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    linkCompra() {
      return `/compra/${this.compraId}/detalhes`;
    },
  },
  components: {
    pxCompraDetalhes: CompraDetalhes,
  },
};
</script>
